module.exports = __webpack_public_path__ + "assets/media/excel_upload.2e0627c8.webm";